module.exports = __webpack_public_path__ + "img/clients-5.6514def7.png";